import { useEffect, useState } from "react";
import * as Styled from "./MyTasksWrapper.styles";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Typography,
  Button,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TaskCard from "@/components/TaskCard";
import { Pagination, Show } from "@adl/smart-ui-library";
import { useAppDispatch, useAppSelector } from "@/hooks";
import LoadingScreen from "@/components/LoadingScreen";
import {
  getOutstandingTasks,
  getInProgressTasks,
  getCompletedTasks,
  selectOutstandingTasks,
  selectInProgressTasks,
  selectCompletedTasks,
  selectIsLoading,
  putVarifiedTasks,
  selectCompletedPagination,
  selectOutstandingPagination,
  selectInProgressPagination,
} from "@/redux/tasksSlice";
import {
  getDocumentCategories,
  selectDocumentCatagories,
  selectDocumentPrivacyLevels,
  getDocumentPrivicyLevels,
} from "@/redux/casesSlice";

import { v4 } from "uuid";
import { motion } from "framer-motion";
import { ANNIMATION_SPEED } from "../../constants";

const MyTasksWrapper = () => {
  const appDispatch = useAppDispatch();
  const isLoading = useAppSelector(selectIsLoading);
  const tasks = useAppSelector(selectOutstandingTasks);
  const inProgessTasks = useAppSelector(selectInProgressTasks);
  const doneTasks = useAppSelector(selectCompletedTasks);
  const categories = useAppSelector(selectDocumentCatagories);
  const privacyLevels = useAppSelector(selectDocumentPrivacyLevels);
  const completePagination = useAppSelector(selectCompletedPagination);
  const outstandingPagination = useAppSelector(selectOutstandingPagination);
  const inProgressPagination = useAppSelector(selectInProgressPagination);
  const [outStandingTaskPage, setOutStandingTasksPage] = useState(0);
  const [inProgressTaskPage, setInProgressTaskPage] = useState(0);
  const [completedTaskPage, setCompletedTaskPage] = useState(0);
  const [searchString, setSearchString] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedType, setSelectedType] = useState(1);
  const [limit] = useState(10);
  const [rerender, setRerender] = useState(false);
  const listItems = [
    { name: "Document name", value: 1 },
    { name: "Project code", value: 2 },
  ];

  useEffect(() => {
    if (!categories || !privacyLevels) {
      appDispatch(getDocumentCategories());
      appDispatch(getDocumentPrivicyLevels());
    }
  }, []);

  const handleVerify = async (payload) => {
    appDispatch(putVarifiedTasks(payload));
  };
  const handleRerender = () => {
    setRerender(!rerender);
  };
  useEffect(() => {
    appDispatch(
      getOutstandingTasks({
        taskStatusType: 3,
        skip: outStandingTaskPage,
        fileNameOriginal: selectedType === 1 ? searchTerm : "",
        p_number: selectedType === 2 ? searchTerm : "",
      })
    );
  }, [outStandingTaskPage, limit, appDispatch, searchTerm]);

  useEffect(() => {
    appDispatch(
      getInProgressTasks({
        taskStatusType: 4,
        skip: inProgressTaskPage,
        fileNameOriginal: selectedType === 1 ? searchTerm : "",
        p_number: selectedType === 2 ? searchTerm : "",
      })
    );
  }, [
    inProgressTaskPage,
    limit,
    appDispatch,
    searchTerm,
    rerender,
    categories,
  ]);

  useEffect(() => {
    appDispatch(
      getCompletedTasks({
        taskStatusType: 5,
        skip: completedTaskPage,
        fileNameOriginal: selectedType === 1 ? searchTerm : "",
        p_number: selectedType === 2 ? searchString : "",
      })
    );
  }, [completedTaskPage, limit, appDispatch, searchTerm, rerender, categories]);

  useEffect(() => {
    appDispatch(
      getOutstandingTasks({
        taskStatusType: 3,
        skip: outStandingTaskPage,
        fileNameOriginal: selectedType === 1 ? searchTerm : "",
        p_number: selectedType === 2 ? searchTerm : "",
      })
    );
  }, [
    outStandingTaskPage,
    limit,
    appDispatch,
    searchTerm,
    rerender,
    categories,
  ]);

  if (!categories || !privacyLevels) {
    return null;
  }

  return (
    <Styled.MyTasksWrapper>
      <Styled.MyTasksWrapperLeft id="document-profile-left">
        <Typography variant="h5">My Tasks</Typography>
        <Box sx={{ display: "flex", gap: "10px" }}>
          <TextField
            label={
              selectedType === 1
                ? `Search Document Name`
                : `Search Project Code`
            }
            sx={{
              minWidth: 300,
              "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                backgroundColor: "white",
                paddingRight: "8px",
              },
            }}
            onChange={(e) => {
              setSearchString(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" && searchString !== "") {
                setSearchTerm(searchString);
              }
            }}
            value={searchString}
          />
          <Select
            variant="outlined"
            sx={{ border: "1px solid #ccc", width: 200 }}
            data-testid="column-selector"
            value={selectedType}
            onChange={(e: any) => {
              setSelectedType(e.target.value);
            }}
          >
            {listItems.map((item) => (
              <MenuItem key={item.value} value={item.value}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
          <Button
            size="small"
            variant="contained"
            disableElevation
            onClick={() => setSearchTerm(searchString)}
            //disabled={isDisabled()}
          >
            Search
          </Button>
          <Button
            variant="text"
            onClick={() => {
              setSearchString("");
              setSearchTerm("");
            }}
            disabled={searchString === "" || isLoading}
          >
            Clear
          </Button>
        </Box>
        <Show>
          <Show.When isTrue={isLoading}>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: ANNIMATION_SPEED }}
            >
              <LoadingScreen />
            </motion.div>
          </Show.When>
          <Show.Else>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: ANNIMATION_SPEED }}
            >
              <Accordion defaultExpanded={true}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Typography variant="h6">To Do</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Show>
                    <Show.When isTrue={!tasks?.length}>
                      <Alert severity="info">
                        You have no outstanding tasks
                      </Alert>
                    </Show.When>
                    <Show.Else>
                      {tasks?.map((task) => (
                        <TaskCard
                          key={v4()}
                          task={task}
                          handleVerify={(p) => handleVerify(p)}
                          onRerender={handleRerender}
                        />
                      ))}
                      {outstandingPagination && (
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          <Pagination
                            totalResults={outstandingPagination.total}
                            resultsPerPage={limit}
                            page={outstandingPagination.skip / limit + 1}
                            onChange={(value) =>
                              setOutStandingTasksPage(value.value as number)
                            }
                          />
                        </Box>
                      )}
                    </Show.Else>
                  </Show>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded={true}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Typography variant="h6">In Progress</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Show>
                    <Show.When isTrue={!inProgessTasks?.length}>
                      <Alert severity="info">
                        You have no in progress tasks
                      </Alert>
                    </Show.When>
                    <Show.Else>
                      {inProgessTasks?.map((task) => (
                        <TaskCard
                          key={v4()}
                          task={task}
                          handleVerify={(p) => handleVerify(p)}
                          onRerender={handleRerender}
                        />
                      ))}
                      {inProgressPagination && (
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          <Pagination
                            totalResults={inProgressPagination.total}
                            resultsPerPage={limit}
                            page={inProgressPagination.skip / limit + 1}
                            onChange={(value) =>
                              setInProgressTaskPage(value.value as number)
                            }
                          />
                        </Box>
                      )}
                    </Show.Else>
                  </Show>
                </AccordionDetails>
              </Accordion>
              <Accordion defaultExpanded={true}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                >
                  <Typography variant="h6">Done</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Show>
                    <Show.When isTrue={!doneTasks?.length}>
                      <Alert severity="info">You have no completed tasks</Alert>
                    </Show.When>
                    <Show.Else>
                      {doneTasks?.map((task) => (
                        <TaskCard key={v4()} task={task} />
                      ))}
                      {completePagination && (
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          <Pagination
                            totalResults={completePagination.total}
                            resultsPerPage={limit}
                            page={completePagination.skip / limit + 1}
                            onChange={(value) =>
                              setCompletedTaskPage(value.value as number)
                            }
                          />
                        </Box>
                      )}
                    </Show.Else>
                  </Show>
                </AccordionDetails>
              </Accordion>
            </motion.div>
          </Show.Else>
        </Show>
      </Styled.MyTasksWrapperLeft>
    </Styled.MyTasksWrapper>
  );
};

export default MyTasksWrapper;
